import { Badge } from '@chakra-ui/react'

export type StatusBadgeStatus = string | number

export interface StatusBadgeConfigItem {
  label: string
  colorPalette: string
}

export type StatusBadgeConfig = Record<string | number, StatusBadgeConfigItem>

export interface StatusBadgeProps {
  status: StatusBadgeStatus
  config: StatusBadgeConfig
  fallback?: StatusBadgeConfigItem
}

const defaultFallback = (status: StatusBadgeStatus): StatusBadgeConfigItem => ({
  label: String(status) || 'Unknown',
  colorPalette: 'gray',
})

export const StatusBadge = ({ status, config, fallback }: StatusBadgeProps) => {
  const own = Object.hasOwn(config, status) ? config[status] : undefined
  const entry = own ?? fallback ?? defaultFallback(status)

  return (
    <Badge
      colorPalette={entry.colorPalette}
      variant="subtle"
      data-color-palette={entry.colorPalette}
    >
      {entry.label}
    </Badge>
  )
}
